import React, { Component } from "react";
import {
    Button,
    Modal,
    Icon
} from "semantic-ui-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createNotification } from "react-redux-notify";

class ConfirmationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    onClose = () => {
        this.props.closePopup();
    };

    discardChanges = () => {
        this.props.discardChangesYes();
    }

    unlinkClients = () => {
        this.props.unlinkClients();
    }
    render() {
        return (
            <Modal
                open={this.props.showPopup}
                closeOnDimmerClick={false}
                centered={true}
                size="tiny">
                <Modal.Header>
                    <strong>Warning</strong>
                    <Icon
                        className="confirmBoxAlign"
                        name="close"
                        onClick={this.onClose}
                    />
                </Modal.Header>
                <Modal.Content
                    scrolling={true}>
                    {
                        (() => {
                           if (this.props.isUnlinkClients)
                                return <p>Are you sure you want to unlink this client?</p>
                            else 
                                return <p>The changes you have made will be discarded. Do you want to proceed?</p>
                        })()
                    }

                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content="No"
                        onClick={this.onClose}
                    />
                    <Button
                        content={"Yes"}
                        primary
                        onClick={

                            (() => {
                              if (this.props.isUnlinkClients)
                                    return this.unlinkClients
                                else
                                    return this.discardChanges
                            })()
                        }
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            createNotification,
        },
        dispatch
    );
}
export default connect(
    mapDispatchToProps
)(ConfirmationModal);
